<div class="filter-section">
  <mat-form-field class="filter-item" style="width: 100%">
    <mat-select
      #select1
      tabindex="100"
      [placeholder]="placeholder"
      [formControl]="doctorControl"
      (selectionChange)="onSelect($event)"
    >
      <mat-select-filter
        *ngIf="select1.focused"
        [array]="doctorList"
        displayMember="name"
        (filteredReturn)="doctorsFilterList = $event"
      ></mat-select-filter>

      <mat-select-trigger>
        {{ getDoctorName() }}
      </mat-select-trigger>

      <mat-option *ngFor="let doctor of doctorsFilterList" [value]="doctor.id">
        {{ doctor.name }}
        <span *ngIf="doctor.isDeleted" class="isDeletedFilter"
          >Deleted user</span
        >
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
